import { render, staticRenderFns } from "./loyalty-points-actions.vue?vue&type=template&id=4c3f43aa"
import script from "./loyalty-points-actions.vue?vue&type=script&lang=js"
export * from "./loyalty-points-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports